import { makeRequest } from 'src/utils/graphql';
import axios from 'axios';
import { DesignerEntity } from '../../types';
import { ArticleEntity } from 'src/modules/articles';
import { ProductEntity } from 'src/modules/products';
import { QUERY_DESIGNERS_DETAILS, QUERY_ALL_DESIGNERS } from '../queries';
import { DesignersDetailsActions } from './types';

//Fetch Designer details
export const fetchDesignersDetailsData = (slug: string) => {
  return async (dispatch) => {
    dispatch(fetchDesignersDetailsDataBegin());

    try {
      const dataResponse = await makeRequest<{
        designers: DesignerEntity[];
        articles: ArticleEntity[];
      }>(QUERY_DESIGNERS_DETAILS, {
        slug,
      });

      const designersResponse = await makeRequest<{
        designers: DesignerEntity[];
      }>(QUERY_ALL_DESIGNERS, {
        designerId: dataResponse.designers[0]?.id || null,
      });
      dispatch(
        fetchDesignersDetailsDataSuccess({
          designer: dataResponse.designers ? dataResponse.designers[0] : null,
          articles: dataResponse.articles,
          designers: designersResponse.designers,
        })
      );
    } catch (e) {
      console.error(e);
      dispatch(fetchDesignersDetailsDataError({ message: e.message }));
    }
  };
};

const fetchDesignersDetailsDataBegin = () => ({
  type: DesignersDetailsActions.FetchDetailsBegin,
});

const fetchDesignersDetailsDataSuccess = (result: {
  designer: DesignerEntity;
  designers: DesignerEntity[];
  articles: ArticleEntity[];
}) => ({
  type: DesignersDetailsActions.FetchDetailsSuccess,
  payload: result,
});

const fetchDesignersDetailsDataError = (error) => ({
  type: DesignersDetailsActions.FetchDetailsError,
  payload: { error },
});

//Fetch Designer products
export const fetchDesignersDetailsProductsData = (slug: string) => {
  return async (dispatch) => {
    dispatch(fetchDesignersDetailsProductsDataBegin());

    try {
      const dataResponse = await axios.post(`${process.env.NEXT_PUBLIC_API_URL}/productSearch`, {
        where: {
          designerSlug: slug,
        },
      });
      // const dataResponse = await makeRequest<{
      //   productsSearch: ProductEntity[];
      // }>(QUERY_DESIGNERS_DETAILS, {
      //   slug,
      // });
      dispatch(fetchDesignersDetailsProductsDataSuccess(dataResponse.data.results));
    } catch (e) {
      console.error(e);
      dispatch(fetchDesignersDetailsProductsDataError({ message: e.message }));
    }
  };
};

const fetchDesignersDetailsProductsDataBegin = () => ({
  type: DesignersDetailsActions.FetchDetailsProductsBegin,
});

const fetchDesignersDetailsProductsDataSuccess = (products: ProductEntity[]) => ({
  type: DesignersDetailsActions.FetchDetailsProductsSuccess,
  payload: products,
});

const fetchDesignersDetailsProductsDataError = (error) => ({
  type: DesignersDetailsActions.FetchDetailsProductsError,
  payload: { error },
});
